<template>
    <div>
        <div
            v-if="isOffline"
            class="has-background-warning has-text-centered py-2"
        >
            You are offline, please reconnect and refresh this page.
        </div>

        <section
            id="header"
            class="section"
            :class="`page-${$route.name}`"
        >
            <div class="container">
                <b-navbar>
                    <template slot="brand">
                        <b-navbar-item
                            href="/"
                            class="title is-3 is-paddingless is-marginless"
                            style="display: contents;"
                        >
                            <img
                                v-if="$meta.features.logo"
                                :src="$meta.logoUrl"
                                :alt="$meta.themeName"
                            />
                            <span v-else>
                                {{ $meta.themeName }}
                            </span>
                        </b-navbar-item>
                    </template>

                    <template slot="end">
                        <template v-if="$meta.isAuth && $meta.is2faPassed">
                            <router-link
                                class="navbar-item"
                                active-class="is-active"
                                :to="{ name: 'dashboard' }"
                            >
                                Dashboard
                            </router-link>

                            <router-link
                                v-if="$meta.isOwner && $meta.features.owners"
                                class="navbar-item"
                                active-class="is-active"
                                :to="{ name: 'portfolio' }"
                            >
                                Portfolio
                            </router-link>

                            <router-link
                                v-if="$meta.isOwner && $meta.features.owners.statements"
                                class="navbar-item"
                                active-class="is-active"
                                :to="{ name: 'accounts' }"
                            >
                                <template v-if="isSalesOrLeaseholdersEnabled">
                                    Lettings Accounts
                                </template>
                                <template v-else>
                                    Accounts
                                </template>
                            </router-link>

                            <router-link
                                v-if="$meta.isOwner && $meta.features.vendors"
                                class="navbar-item"
                                active-class="is-active"
                                :to="{ name: 'sales-properties' }"
                            >
                                Sales
                            </router-link>

                            <router-link
                                v-if="$meta.isOwner && $meta.features.leaseholders"
                                class="navbar-item"
                                active-class="is-active"
                                :to="{ name: 'leasehold-properties' }"
                            >
                                Leaseholders
                            </router-link>

                            <router-link
                                v-if="$meta.isTenantOrLettingsApplicant && $meta.features.tenants"
                                class="navbar-item"
                                active-class="is-active"
                                :to="{ name: 'tenancies' }"
                            >
                                Tenancies
                            </router-link>

                            <b-navbar-dropdown
                                v-if="$meta.isAuth && ! $meta.isLead && ! $meta.isStaff"
                                label="Profile"
                                :hoverable="true"
                            >
                                <b-navbar-item
                                    tag="router-link"
                                    exact
                                    active-class="is-active"
                                    :to="{ name: 'profile' }"
                                >
                                    Profile
                                </b-navbar-item>

                                <b-navbar-item
                                    v-if="$meta.isImpersonating"
                                    tag="a"
                                    href="/admin/impersonate/leave"
                                    active-class="is-active"
                                    :title="`Stop impersonating ${$meta.userName}`"
                                >
                                    Leave impersonation
                                </b-navbar-item>

                                <b-navbar-item
                                    v-if="! $meta.isImpersonating"
                                    tag="a"
                                    href="/logout"
                                    active-class="is-active"
                                >
                                    Logout
                                </b-navbar-item>
                            </b-navbar-dropdown>
                        </template>

                        <template v-if="! $meta.isAuth && ! $route.meta.isAdmin">
                            <router-link
                                class="navbar-item"
                                exact
                                active-class="is-active"
                                :to="{ name: 'sign-up' }"
                            >
                                Sign up
                            </router-link>

                            <router-link
                                class="navbar-item"
                                exact
                                active-class="is-active"
                                :to="{ name: 'login' }"
                            >
                                Log in
                            </router-link>
                        </template>

                        <template v-if="! $meta.isAuth && $meta.features.staff_access && $route.meta.isAdmin">
                            <router-link
                                class="navbar-item"
                                exact
                                active-class="is-active"
                                :to="{ name: 'staff-sign-up' }"
                            >
                                Sign up
                            </router-link>

                            <router-link
                                class="navbar-item"
                                exact
                                active-class="is-active"
                                :to="{ name: 'staff-login' }"
                            >
                                Log in
                            </router-link>
                        </template>

                        <a
                            v-if="$meta.isAuth && ($meta.isStaff || ! $meta.is2faPassed)"
                            href="/logout"
                            class="navbar-item"
                        >
                            Logout
                        </a>

                        <a
                            v-if="$meta.features.contact_details"
                            href="#"
                            class="navbar-item"
                            title="Contact us"
                            @click.prevent="isContactModalActive = true"
                        >
                            <span class="is-hidden-desktop">
                                Contact
                            </span>
                            <b-icon
                                pack="far"
                                icon="question-circle"
                                size="is-small"
                                class="ml-1 mr-2 is-hidden-touch"
                            />
                        </a>

                    </template>
                </b-navbar>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="app-wrapper">
                    <router-view />
                </div>

                <p class="has-text-centered has-text-grey-light mb-5">
                    &copy; {{ $meta.themeName }} {{ new Date().getFullYear() }}
                </p>
            </div>
        </section>

        <ContactModal />
    </div>
</template>

<script>
import { VueOfflineMixin } from 'vue-offline';
import ContactModal from '../components/ContactModal';

export default {
    components: {
        ContactModal,
    },

    mixins: [
        VueOfflineMixin,
    ],

    data: function() {
        return {
            isContactModalActive: false,
        };
    },

    computed: {
        isSalesOrLeaseholdersEnabled: function () {
            return (this.$meta.isOwner && (this.$meta.features.vendors || this.$meta.features.leaseholders));
        },
    },
};
</script>
